import React from 'react';

import { CodeBlock } from 'react-code-blocks';

const programmingBibtex = `@article{buffardi2021programming,
    title={Is programming relevant to CS1 students' interests?},
    author={Buffardi, Kevin and Chavan, Subhed},
    journal={Journal of Computing Sciences in Colleges},
    volume={37},
    number={1},
    pages={45--53},
    year={2021},
    publisher={Consortium for Computing Sciences in Colleges}
}`;

const vehicleEmissionsBibtex = `@article{chavan2019remote,
    author={Chavan, Subhed and Shetty, Sahil and Chandran, Sidharth and Khade, Anindita},
    title={Remote Sensing Technique for Monitoring and Reducing Harmful Gas Emissions from Vehicles},
    journal={International Journal of Research and Analytical Reviews},
    volume={6},
    number={1},
    pages={453--457},
    year={2019},
    month=mar,
    issn={2348-1269},
    url={https://www.ijrar.org/papers/IJRAR19H1217.pdf},
    note={Paper ID: IJRAR19H1217}
}`;

const CodeBlockDefaultExample = ({ text = programmingBibtex }) => {
  return (
    <CodeBlock language="text" showLineNumbers={true} text={text} />
  );
};

export { vehicleEmissionsBibtex };
export default CodeBlockDefaultExample;
